import { useState } from "react";

const LANG_KEY = "flautreach-lang";

function detectLang() {
  const stored = (() => {
    try {
      return localStorage.getItem(LANG_KEY);
    } catch (e) {
      return null;
    }
  })();
  
  if (stored === "en" || stored === "pl") return stored;
  
  const browser = (navigator.language || navigator.userLanguage || "").toLowerCase();
  if (browser.startsWith("pl")) return "pl";
  return "en";
}

export function useLang() {
  const [lang, setLangState] = useState(detectLang);

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem(LANG_KEY, l);
    } catch (e) {
      // localStorage might not be available
    }
  };

  return { lang, setLang };
}